import { render, staticRenderFns } from "./sendMessagesInApp.vue?vue&type=template&id=00527f78&scoped=true"
import script from "./sendMessagesInApp.vue?vue&type=script&lang=js"
export * from "./sendMessagesInApp.vue?vue&type=script&lang=js"
import style0 from "./sendMessagesInApp.vue?vue&type=style&index=0&id=00527f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00527f78",
  null
  
)

export default component.exports